const initialState = {
    rucList: [],
    loaded: false
}

export const rucReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'GET_ALL_RUCS': return {
            ...state,
            rucList: action.payload
        }
        case 'RUC_LOADED': return {
            ...state,
            loaded: action.payload
        }
        default: return state
    }
}